require('summernote/dist/summernote.css');
require('summernote/dist/summernote');
require('angular-summernote');

/*@ngInject*/
const EmailSignatureModalController = function ($scope, $stateParams, options, localization, organizationType, currentUserModel, authorizationConstants) {

    function init() {
        var canUpdateEmailSignature = false;

        $scope.originalEmailSignature = _.isEmpty(options.emailSignature) ? '' : options.emailSignature;

        $scope.viewModel = {
            isConfirmDisabled: true,
            emailSignature: $scope.originalEmailSignature,
            emailSignatureConfigured: !_.isEmpty($scope.originalEmailSignature)
        };

        $scope.summernoteOptions = {
            toolbar: [
                ['style', ['style']],
                ['font', ['bold', 'underline', 'italic', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['insert', ['link', 'attachment']]
            ],
            dialogsInBody: true,
            disableResizeEditor: true,
            disableLinkTarget: true,
            defaultLinkTargetNewWindow: true,
            disableDragAndDrop: true,
            fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Helvetica', 'Impact', 'Lato', 'Tahoma', 'Times New Roman', 'Verdana'],
            onCreateLink: function (linkUrl) {
                return encodeURI(linkUrl);
            },
            onCreateLinkText: function (linkText) {
                return encodeURI(linkText);
            }
        };

        switch (parseInt($stateParams.organizationType)) {
            case organizationType.AGENCY:
                canUpdateEmailSignature = currentUserModel.hasAuthorization(authorizationConstants.MODIFY_CONFIG_AGENCY_BROKERAGE);
                break;

            case organizationType.CARRIER:
                canUpdateEmailSignature = currentUserModel.hasAuthorization(authorizationConstants.MODIFY_CONFIG_CARRIERS);
                break;

            case organizationType.MGA_AGENCY:
                canUpdateEmailSignature = currentUserModel.hasAuthorization(authorizationConstants.MODIFY_CONFIG_MGA_AGENCY_BROKERAGE);
                break;

            case organizationType.MGA_CARRIER:
                canUpdateEmailSignature = currentUserModel.hasAuthorization(authorizationConstants.MODIFY_CONFIG_MGA_CARRIERS);
                break;
        }

        $scope.viewModel.canUpdateEmailSignature = canUpdateEmailSignature;

        localization.getTranslationByKey('emailSignatureModal').then(function (translations) {
            $scope.viewModel.title = _.get(translations, 'title');
            $scope.viewModel.okButtonLabel = _.get(translations, 'okButtonLabel');
            $scope.viewModel.cancelButtonLabel = _.get(translations, 'cancelButtonLabel');
            $scope.viewModel.emailSignatureNotConfigured = _.get(translations, 'emailSignatureNotConfigured');
        });
    }

    $scope.onConfirm = function () {
        $scope.$close({
            emailSignature: $scope.viewModel.emailSignature
        });
    };

    $scope.onCancel = function () {
        $scope.$dismiss();
    };

    $scope.$watch('viewModel.emailSignature', function () {
        if ($scope.viewModel.emailSignature !== $scope.originalEmailSignature) {
            $scope.viewModel.isConfirmDisabled = false;
        } else {
            $scope.viewModel.isConfirmDisabled = true;
        }
    });

    init();
};

angular.module('ums.configuration')
    .controller('emailSignatureModalController', EmailSignatureModalController);
